import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';

import { FormattedText } from '#client/pages/EducationStudio/components/FormattedText/FormattedText';

import {
  BackButtonContainer, BackIcon, Container, ExitButtonContainer, ExitIcon, TitleContainer
} from './Header.styles';

import { useBreakpoints } from '../../../hooks';

export const Header = ({
  title, showBackButton, onBack, onClose
}) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return (
    <Container aria-label="header">
      <BackButtonContainer>
        {showBackButton && (
        <IconButton aria-label="back" onClick={onBack}>
          <BackIcon />
        </IconButton>
        )}
      </BackButtonContainer>
      <TitleContainer
        sx={{
          marginLeft: !showBackButton && isMobile ? '1rem' : ''
        }}
      >
        <FormattedText
          size={isMobile ? 'lg' : 'xl'}
          bold={!isMobile}
          tag="span"
          dirtyText={title}
        />
      </TitleContainer>
      <ExitButtonContainer>
        <IconButton aria-label="exit" onClick={onClose}>
          <ExitIcon />
        </IconButton>
      </ExitButtonContainer>
    </Container>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
  onClose: PropTypes.func
};

Header.defaultProps = {
  showBackButton: true,
  onBack: () => {}
};
